'use client';

import { upperFirst } from 'lodash-es';
import dynamic from 'next/dynamic';

import { Publication } from '@/shared/types';

const DeletePublicationButton = dynamic(
  () => import('@/entities/admin').then((m) => m.DeletePublicationButton),
  {
    ssr: false
  }
);

interface PublicationDescriptionProps {
  publication: Publication | null;
}

export function PublicationDescription({ publication }: PublicationDescriptionProps) {
  if (!publication) return null;

  return (
    <article className="space-y-8">
      <h2 className="grid grid-cols-12 gap-4 pt-4 text-left text-2xl md:text-3xl">
        <span className="col-span-2 font-semibold">
          {upperFirst(publication.publicationType!)}&nbsp;
        </span>
        <span className="col-span-full font-medium md:col-span-10 xl:col-span-10">
          {publication.title}
        </span>
      </h2>
      <div className="grid grid-cols-12 md:gap-8">
        <h2 className="col-span-2 pb-2 text-left text-2xl font-semibold md:pb-6">Описание</h2>
        {/* INFO: DeletePublicationButton is only visible to the author of the publication */}
        <DeletePublicationButton pubId={publication.id} authorEmail={publication.author?.email} />
        <p className="col-span-full text-left whitespace-pre-line md:col-span-10 xl:col-span-10">
          {publication.description}
        </p>
      </div>
    </article>
  );
}
